<template lang="pug">
b-modal#deleteThemeContent(
  ref="deleteThemeContent"
  :title="$t('ui.combine.delete_content')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.content_id')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="content_id"
        required
        type="text"
        v-model="content_id"
        :disabled="loading"
      )
    b-form-group(:label="$tc('ui.content_group')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="content_group"
        required
        type="text"
        v-model="content_group"
        :disabled="loading"
      )
    b-form-group(:label="$tc('ui.position')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="position"
        required
        type="text"
        v-model="position"
        :disabled="loading"
      )
    b-form-group(:label="$t('ui.sync_site_content')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="sync_exist")
        span.custom-switch-indicator


    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import config from "@/config";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    itemContent: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      sync_exist: false,
      position: '',
      content_id: '',
      theme_content_id: '',
      content_group: '',
    };
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      let url = config.deleteThemeContentUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_content_id: this.theme_content_id,
        sync_exist_site_content: this.sync_exist
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "combine.delete", this.feedback.status);
              }
              this.$nextTick(() => {
                this.$refs.deleteThemeContent.hide();
              });
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
              this.$nextTick(() => {
                this.$refs.deleteThemeContent.hide();
              });
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = response.data.status;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    reset() {
      this.sync_exist = false;
      this.content_id = "";
      this.position = "";
      this.content_group = ""
      this.theme_content_id = ""
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.theme_content_id = this.itemContent.theme_content_id;
      this.content_id = this.itemContent.content_id;
      this.position = this.itemContent.position;
      this.content_group = this.itemContent.theme_content_group;
    }
  }
};
</script>
